import { RESOURCE_TYPE_ICONS } from 'v1/helpers/iconSets';
import { cn } from 'v5/platform/dom/cn';

type ResourceTypeIconProps = {
  icon?: string;
  alt?: string;
  className?: string;
};

/** The type's image in black, or in white under `dark`. */
export function ResourceTypeIcon({
  icon,
  alt = '',
  className
}: ResourceTypeIconProps) {
  const images =
    RESOURCE_TYPE_ICONS[icon && icon in RESOURCE_TYPE_ICONS ? icon : 'default'];
  return (
    <>
      <img
        src={`/images/${images.black}`}
        alt={alt}
        className={cn('size-5 shrink-0 dark:hidden', className)}
      />
      <img
        src={`/images/${images.white}`}
        alt={alt}
        className={cn('size-5 shrink-0 not-dark:hidden', className)}
      />
    </>
  );
}
